<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps" @del="del" ref="SetBtn"></buttonlist>
        <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" @tab-click="selectInfo" value="0">
            <el-tab-pane :label="$t('getapi[8288]')" name="0">
                <wTable
                        id="xpane-0"
                        :data="dataSet.DataContent"
                        :loading="loading"
                        queryData="V_ENG_TM_Show"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable"
                        :filter_language="['Order_Status']"
                ></wTable>
                <!--<el-table
                        id="xpane-0"
                        :data="dataSet.DataContent"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight - reduceTableHeight"
                        header-row-class-name="headerclass"
                        @selection-change="handleSelectionChange"

                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code"
                                     :label="$t('getapi[2863]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version"
                                     :label="$t('getapi[113]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[552]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CREATE_TIME"
                                     :label="$t('getapi[6412]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code"
                                     :label="$t('getapi[876]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_duty_person"
                                     :label="$t('getapi[6403]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Plan_Date"
                                     :label="$t('getapi[6222]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="数控冲/冲模"
                                     :label="$t('getapi[8280]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['数控冲/冲模'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="数控折/折弯模"
                                     :label="$t('getapi[8281]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['数控折/折弯模'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="压PEM/压铆模具"
                                     :label="$t('getapi[8282]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['压PEM/压铆模具'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="焊接/焊接工装"
                                     :label="$t('getapi[8283]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['焊接/焊接工装'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="喷粉/喷涂挂具"
                                     :label="$t('getapi[8284]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['喷粉/喷涂挂具'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="喷漆/喷涂挂具"
                                     :label="$t('getapi[8285]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['喷漆/喷涂挂具'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="所有自制件/周转器具"
                                     :label="$t('getapi[8286]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['所有自制件/周转器具'])}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="所有自制件/CMM测量提出"
                                     :label="$t('getapi[8287]')">
                        <template slot-scope="scope" >
                            {{exp(scope.row['所有自制件/CMM测量提出'])}}
                        </template>
                    </el-table-column>
                </el-table>-->
                <!--<vxe-table :data="dataSet.DataContent" size="mini" :loading="loading" :height="tableHeight - reduceTableHeight" stripe border resizable>
                    <vxe-table-column show-footer-overflow v-for="item in dataSet.TbHeader"
                                      :key="item.Headen"
                                      :field="item.Headen"
                                      :title="item.Headcn"
                                      width="180px"
                    ></vxe-table-column>
                </vxe-table>-->
                <el-row class="page">
                    <el-col :span="18">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[100, 200, 300, 400]"
                                :page-size="pageSize"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                        ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{
                            DbTbNames }}
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <!--<el-tab-pane :label="$t('getapi[6266]')" name="1">
                <el-table
                        :data="dataSet1"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        @selection-change="handleSelectionChange"

                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="TM_NAME"
                                     label="TM_NAME"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="TM_N2"
                                     :label="$t('getapi[6253]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="TM_N1"
                                     :label="$t('getapi[6264]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="TM_TIME"
                                     :label="$t('getapi[6265]')"></el-table-column>
                    </el-table>
            </el-tab-pane>-->
        </el-tabs>
        <serce :isVisible="isVisible" queryData="V_ENG_TM_Show" ref="ser"
               @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6534]')" queryData="V_ENG_TM_Show" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
      
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
		name:'tmdetail',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: {
                    TbHeader: [],
                    DataContent: []
                }, // 全部
                dataSet1: [], // 生成
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                DbTbNames1: '',
                pageIndex: 0, // 当前页
                pageSize: this.$http.getPageSize('tmdetail'), // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: 100, // 当前页数据量
                SelectIndex: 0, //当前页面
                total: 0, // 全部数据总量
                total1: 0, // 生成数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                selectData: [], // 多选数组
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('V_ENG_TM_Show', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6534]"),this.$t("getapi[18]"));
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 520, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 520, 1) == 2) {
                    if (that.$limits.authority('plv3', 520,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 520,1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 520, 1) == 2) {
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                let that = this;
                that.pageSize = val;
                this.$http.savePageSize('tmdetail',val)
                that.getView();
                that.authority();
            },
            handleCurrentChange(val) {
                let that = this;
                that.pageIndex = val;
                that.getView();
                that.authority();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'V_ENG_TM_Show');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                if(that.SelectIndex == 0){
                    that.loading = true;
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let token = JSON.parse(that.userData).token;
                    let data = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        SelectIndex: that.SelectIndex,
                        Param: datac
                    };
                    that.$http.urlpost('/Eng/TMView/GetTMShowView', data, function (res) {
                        if (res.Success == 1) {
                            that.dataSet.DataContent = res.DataContent
                            that.dataSet.TbHeader = res.TbHeader
                            that.total = res.Totals
                            that.loading = false;
                            that.DbTbNames = res.DbTbNames;
                            that.authority();
                        }
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    });
                } else {
                    that.$http.urlpost('/Eng/TMView/GetTMShowTotalView', '', function (res) {
                        if (res.Success == 1) {
                            that.dataSet1 = res.DataContent
                            that.loading = false;
                            that.DbTbNames1 = res.DbTbNames;
                            that.authority();
                        }
                    });
                }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Eng/TMView/GetTMShowViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "V_ENG_TM_Show",
                    fromname: that.$t('getapi[8288]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            selectInfo(tab) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        let lan = that.$processdata.getLang()
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                Order_No: that.selectData[i].Order_No,
                                MODIFY_TIME: that.selectData[i].MODIFY_TIME,
                                LangType: lan
                            }]
                        }
                        let parm = arr
                        that.$http.urlpost('/Eng/TMView/DeleteTMShow', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            exp(val){
                let that = this
                if(val == 0){
                    return '否'
                } else if (val == 1){
                    return '是'
                } else if(val == 3){
                    return '待处理'
                } else {
                    return ''
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .blue {
        background: #9dd9ff;
    }
</style>
